import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useShowLoungeBanner = () => {
  const [isShowBanner, setIsShowBanner] = useState(true);

  const [searchParams] = useSearchParams();
  const categoryGroup = searchParams.get('categoryGroup');

  const isWishLounge = categoryGroup === 'nctwish';

  return {
    isShowBanner,
    setIsShowBanner,
    isWishLounge
  };
};
